import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";

import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui-next/Dialog";

import Divider from "material-ui/Divider";

import {
  CfopValues,
  PisValues,
  CofinsValues,
  OriginValues,
  CsosnValues,
  IcmsValues,
  ModbcValues,
  ModbcstValues,
  MotdesicmsValues
} from "core/enum";

import {
  TextField,
  CheckBox,
  Loadable,
  StyledButton,
  SelectField,
  CurrencyField,
  If
} from "components/support";

import Icon from "material-ui-next/Icon";
import Paper from "material-ui-next/Paper";
import Tooltip from "material-ui-next/Tooltip";
import Typography from "material-ui-next/Typography";

import { colors } from "assets";

class BatchFiscalInformationsDialogView extends Component {
  defaultFiscalInformations = (taxes, errors, presenter) => (
    <Row>
      <Col xs={12}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div>
            <CheckBox
              checked={taxes.use_default_configuration}
              label="Usar Configuração Geral"
              style={{ padding: "10px 0px 0px" }}
              onCheck={() => presenter.onDefaultConfigurationChange()}
            />
          </div>
          <div style={{ padding: "18px 0 0 6px" }} className="full-height">
            <Row middle="xs" className="full-height">
              <Col xs className="full-height">
                <Tooltip
                  key="tooltip-right"
                  title="Acesse a Área do Contador para modificar a Configuração Geral."
                  placement="top"
                >
                  <Icon style={{ color: colors.primary.dark }}>info</Icon>
                </Tooltip>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
      <Col xs={12} lg={6}>
        <TextField
          maskPattern={[
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            ".",
            /\d/,
            /\d/,
            ".",
            /\d/,
            /\d/
          ]}
          fullWidth
          value={taxes.ncm}
          errorText={errors.ncm}
          label="NCM (Código do Mercosul)"
          onChange={(_, value) => (taxes.ncm = value.replace(/\D/g, ""))}
        />
      </Col>
      <Col xs={12} lg={6}>
        <TextField
          maskPattern={[/\d/, /\d/, ".", /\d/, /\d/, /\d/, ".", /\d/, /\d/]}
          fullWidth
          value={taxes.cest}
          errorText={errors.cest}
          label="CEST"
          onChange={(_, value) => (taxes.cest = value.replace(/\D/g, ""))}
        />
      </Col>
    </Row>
  );

  renderFieldsCrtNationalSimple = (taxes, errors, presenter) => (
    <Row>
      <Col xs={12} lg={6}>
        <SelectField
          fullWidth
          options={CsosnValues}
          value={taxes.csosn}
          errorText={errors["taxes.csosn"]}
          label="CSOSN"
          onChange={(_, value) => presenter.enqueueField("csosn", value)}
        />
      </Col>
      <Col xs={12} lg={6}>
        <SelectField
          fullWidth
          disabled={["", "none"].includes(taxes.csosn) ? true : false}
          options={CfopValues[taxes.csosn] || CfopValues["none"]}
          value={taxes.cfop}
          errorText={errors.cfop}
          label="CFOP"
          onChange={(_, value) => presenter.enqueueField("cfop", value)}
        />
      </Col>
      <Col xs={12} lg={6}>
        <SelectField
          fullWidth
          options={PisValues}
          value={taxes.pis}
          errorText={errors.pis}
          label="PIS"
          onChange={(_, value) => presenter.enqueueField("pis", value)}
        />
      </Col>
      <Col xs={12} lg={6}>
        <SelectField
          fullWidth
          options={CofinsValues}
          value={taxes.cofins}
          errorText={errors.cofins}
          label="COFINS"
          onChange={(_, value) => presenter.enqueueField("cofins", value)}
        />
      </Col>
      <Col xs={12} lg={6}>
        <SelectField
          fullWidth
          options={OriginValues}
          value={taxes.origin}
          errorText={errors.origin}
          label="ORIGEM"
          onChange={(_, value) => presenter.enqueueField("origin", value)}
        />
      </Col>
    </Row>
  );

  renderFieldsCrtRegimeNormal = (
    taxes,
    errors,
    fiscal_informations,
    presenter
  ) => {
    return (
      <Row className="mt-sm">
        <Col xs>
          <Row>
            <Col xs={12}>
              <Paper
                elevation={3}
                style={{ width: "100%", padding: 8, margin: "10px 0" }}
              >
                <Typography type="title">PIS</Typography>
                <SelectField
                  fullWidth
                  options={PisValues}
                  label="CST"
                  required={true}
                  disabled={fiscal_informations.crt_code === "3" ? false : true}
                  value={taxes.pis_normal ? taxes.pis_normal.cst || "" : ""}
                  onChange={(_, value) =>
                    presenter.enqueueSubField("pis_normal", "cst", value)
                  }
                />

                <If
                  test={
                    taxes.pis_normal &&
                    ["01", "02", "49", "99"].includes(taxes.pis_normal.cst)
                  }
                >
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    value={taxes.pis_normal ? taxes.pis_normal.pPIS || "0" : ""}
                    label="Alíquota do PIS (em %)"
                    suffix=" %"
                    required={true}
                    errorText={
                      taxes.pis_normal && !taxes.pis_normal.pPIS
                        ? "Preenchimento obrigatório"
                        : ""
                    }
                    onChange={(_, value) =>
                      presenter.enqueueSubField("pis_normal", "pPIS", value)
                    }
                  />
                </If>

                <If
                  test={
                    taxes.pis_normal && ["03"].includes(taxes.pis_normal.cst)
                  }
                >
                  <CurrencyField
                    allowNegative={false}
                    required={true}
                    errorText={
                      taxes.pis_normal && !taxes.pis_normal.vAliqProd
                        ? "Preenchimento obrigatório"
                        : ""
                    }
                    fullWidth
                    value={
                      taxes.pis_normal ? taxes.pis_normal.vAliqProd || "0" : ""
                    }
                    label="Alíquota do PIS (em R$)"
                    unit="R$ "
                    onChange={(_, value) =>
                      presenter.enqueueSubField(
                        "pis_normal",
                        "vAliqProd",
                        value
                      )
                    }
                  />
                </If>
              </Paper>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Paper
                elevation={3}
                style={{ width: "100%", padding: 8, margin: "10px 0" }}
              >
                <Typography type="title">COFINS</Typography>
                <SelectField
                  fullWidth
                  options={CofinsValues}
                  label="CST"
                  value={
                    taxes.cofins_normal ? taxes.cofins_normal.cst || "" : ""
                  }
                  onChange={(_, value) =>
                    presenter.enqueueSubField("cofins_normal", "cst", value)
                  }
                />

                <If
                  test={
                    taxes.cofins_normal &&
                    ["01", "02", "49"].includes(taxes.cofins_normal.cst)
                  }
                >
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    required={true}
                    errorText={
                      taxes.cofins_normal && !taxes.cofins_normal.pCOFINS
                        ? "Preenchimento obrigatório"
                        : ""
                    }
                    unit=""
                    value={
                      taxes.cofins_normal
                        ? taxes.cofins_normal.pCOFINS || "0"
                        : ""
                    }
                    label="Alíquota do COFINS (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField(
                        "cofins_normal",
                        "pCOFINS",
                        value
                      )
                    }
                  />
                </If>

                <If
                  test={
                    taxes.cofins_normal &&
                    ["03"].includes(taxes.cofins_normal.cst)
                  }
                >
                  <CurrencyField
                    allowNegative={false}
                    fullWidth
                    required={true}
                    errorText={
                      taxes.cofins_normal && !taxes.cofins_normal.vAliqProd
                        ? "Preenchimento obrigatório"
                        : ""
                    }
                    value={
                      taxes.cofins_normal
                        ? taxes.cofins_normal.vAliqProd || "0"
                        : ""
                    }
                    label="Alíquota do COFINS (em R$)"
                    unit="R$ "
                    onChange={(_, value) =>
                      presenter.enqueueSubField(
                        "cofins_normal",
                        "vAliqProd",
                        value
                      )
                    }
                  />
                </If>
              </Paper>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <Paper
                elevation={3}
                style={{ width: "100%", padding: 8, margin: "10px 0" }}
              >
                <Typography type="title">ICMS</Typography>
                <SelectField
                  fullWidth
                  options={IcmsValues}
                  label="CST"
                  value={taxes.icms ? taxes.icms.cst || "" : ""}
                  onChange={(_, value) =>
                    presenter.enqueueSubField("icms", "cst", value)
                  }
                />
                <If
                  test={
                    taxes.icms &&
                    !["none", "", undefined].includes(taxes.icms.cst)
                  }
                >
                  <SelectField
                    fullWidth
                    label="CFOP"
                    required={true}
                    errorText={
                      taxes.icms
                        ? ["none", "", undefined].includes(taxes.icms.cfop)
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    options={
                      taxes.icms && taxes.icms.cst
                        ? CfopValues[taxes.icms.cst]
                        : []
                    }
                    value={taxes.icms ? taxes.icms.cfop || "" : ""}
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "cfop", value)
                    }
                  />
                </If>

                <If
                  test={
                    taxes.icms && ["00", "10", "20"].includes(taxes.icms.cst)
                  }
                >
                  <SelectField
                    fullWidth
                    options={ModbcValues}
                    label="Modalidade de determinação da BC do ICMS"
                    required={true}
                    errorText={
                      taxes.icms
                        ? ["none", "", undefined].includes(taxes.icms.modBC)
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    value={taxes.icms ? taxes.icms.modBC || "" : ""}
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "modBC", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    disabled={false}
                    precision={2}
                    separator=""
                    fullWidth
                    required={true}
                    errorText={
                      taxes.icms && taxes.icms.pICMS === ""
                        ? "Preenchimento obrigatório"
                        : ""
                    }
                    unit=""
                    value={taxes.icms ? taxes.icms.pICMS || "" : ""}
                    label="Alíquota do imposto do ICMS (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pICMS", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    disabled={false}
                    precision={2}
                    separator=""
                    fullWidth
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pFCP === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    unit=""
                    value={taxes.icms ? taxes.icms.pFCP || "0.00" : "0.00"}
                    label="Percentual do Fundo de Combate à Pobreza (FCP) (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pFCP", value)
                    }
                  />
                </If>

                <If test={taxes.icms && ["10", "30"].includes(taxes.icms.cst)}>
                  <SelectField
                    fullWidth
                    options={ModbcstValues}
                    label="Modalidade de determinação da BC do ICMS ST"
                    required={true}
                    errorText={
                      taxes.icms &&
                      ["none", "", undefined].includes(taxes.icms.modBCST)
                        ? "Preenchimento obrigatório"
                        : ""
                    }
                    value={taxes.icms ? taxes.icms.modBCST || "" : ""}
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "modBCST", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    value={taxes.icms ? taxes.icms.pMVAST || "0" : ""}
                    label="Percentual da margem de valor Adicionado do ICMS ST (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pMVAST", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    value={taxes.icms ? taxes.icms.pRedBCST || "0" : "0"}
                    label="Percentual da Redução de BC do ICMS ST (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pRedBCST", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pICMSST === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    unit=""
                    value={taxes.icms ? taxes.icms.pICMSST || "0" : ""}
                    label="Alíquota do imposto do ICMS ST (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pICMSST", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pFCPST === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    value={taxes.icms ? taxes.icms.pFCPST || "0" : ""}
                    label="Percentual do FCP retido por Substituição Tributária (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pFCPST", value)
                    }
                  />
                </If>

                <If test={taxes.icms && ["20"].includes(taxes.icms.cst)}>
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    value={taxes.icms ? taxes.icms.pRedBC || "0" : ""}
                    label="Percentual da Redução de BC do ICMS (em %)"
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pRedBC === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pRedBC", value)
                    }
                  />
                </If>

                <If test={taxes.icms && ["20", "30"].includes(taxes.icms.cst)}>
                  <SelectField
                    fullWidth
                    options={MotdesicmsValues}
                    label="Motivo da desoneração do ICMS."
                    required={true}
                    errorText={
                      taxes.icms
                        ? ["none", "", undefined].includes(
                            taxes.icms.motDesICMS
                          )
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    value={taxes.icms ? taxes.icms.motDesICMS || "" : ""}
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "motDesICMS", value)
                    }
                  />
                </If>
                <If test={taxes.icms && ["60"].includes(taxes.icms.cst)}>
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pST === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    value={taxes.icms ? taxes.icms.pST || "0" : "0"}
                    label="Alíquota suportada pelo Consumidor Final (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pST", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    precision={2}
                    separator=""
                    fullWidth
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pFCPSTRet === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    unit=""
                    value={taxes.icms ? taxes.icms.pFCPSTRet || "0" : "0"}
                    label="Percentual do FCP retido anteriormente por Substituição Tributária (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pFCPSTRet", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    disabled={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pRedBCEfet === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    value={taxes.icms ? taxes.icms.pRedBCEfet || "0" : "0"}
                    label="Percentual de redução da base de cálculo efetiva (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pRedBCEfet", value)
                    }
                  />
                  <CurrencyField
                    allowNegative={false}
                    disabled={false}
                    precision={2}
                    separator=""
                    fullWidth
                    unit=""
                    value={taxes.icms ? taxes.icms.pICMSEfet || "0" : "0"}
                    required={true}
                    errorText={
                      taxes.icms
                        ? taxes.icms.pICMSEfet === ""
                          ? "Preenchimento obrigatório"
                          : ""
                        : ""
                    }
                    label="Alíquota do ICMS efetiva (em %)"
                    suffix=" %"
                    onChange={(_, value) =>
                      presenter.enqueueSubField("icms", "pICMSEfet", value)
                    }
                  />
                </If>
              </Paper>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <SelectField
                errorText={errors["taxes.origin"]}
                fullWidth
                options={OriginValues}
                label="ORIGEM"
                value={taxes.origin}
                onChange={(_, value) => presenter.enqueueField("origin", value)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    );
  };

  render() {
    const {
      batchFiscalInformationsDialogOpen,
      loading,
      onClose,
      presenter
    } = this.props;
    const { viewModel } = presenter;
    const { taxes, errors, fiscal_informations } = viewModel || {};

    return (
      <Dialog
        open={batchFiscalInformationsDialogOpen}
        onClose={() => onClose()}
        style={{ textAlign: "center" }}
      >
        <Loadable loading={loading}>
          <DialogTitle style={{ padding: "16px 24px 4px" }}>
            Alteração de informações fiscais em lote
          </DialogTitle>

          <DialogContent style={{ width: "100%", maxWidth: "none" }}>
            <div className="grid-container mt-sm mb-sm">
              <Divider />

              {this.defaultFiscalInformations(taxes, errors, presenter)}

              <If test={!taxes.use_default_configuration}>
                <If
                  test={
                    fiscal_informations.crt_code === "1" ||
                    fiscal_informations.crt_code === "2"
                  }
                >
                  {this.renderFieldsCrtNationalSimple(taxes, errors, presenter)}
                </If>

                <If test={fiscal_informations.crt_code === "3"}>
                  {this.renderFieldsCrtRegimeNormal(
                    taxes,
                    errors,
                    fiscal_informations,
                    presenter
                  )}
                </If>
              </If>
            </div>
          </DialogContent>

          <DialogActions>
            <StyledButton flat label="Voltar" onClick={() => onClose()} />

            <StyledButton
              primary
              label="Confirmar"
              onClick={() => presenter.onConfirmBatchFiscalInformations(taxes)}
            />
          </DialogActions>
        </Loadable>
      </Dialog>
    );
  }
}

export default BatchFiscalInformationsDialogView;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/data-table/batch-fiscal-informations-modal/view.jsx